/*!
 *
 * Copyright 2014 Dmytro Kerest
 */

import 'formdata-polyfill';

jQuery(function ($) {
    'use strict';
    $('.climb-app-form #save').on('click', e => {
        e.preventDefault();
        // console.log('prevented');
    });

    $('#climb-application-confirm-popup')
        .on('show.bs.modal', function (event) {
            // console.log('show.popup', window.caConfig);
            const formData = new FormData(document.querySelector('.climb-app-form form'));
            const $modalBody = $('#climb-application-confirm-popup .modal-body table');
            const FormDataMap = new Map();

            $modalBody.empty();
            for (const entry of formData.entries()) {
                FormDataMap.set(entry[0], entry[1])
            }
            // formData.entries().forEach(entry => { FormDataMap.set(entry[0], entry[1]) });

            FormDataMap.forEach((value, name) => {
                let label = null;

                try{
                    label = document.querySelector('[name='+name+']').closest('.group-row');
                } catch(err) {
                    console.log('no label on name: ', name);
                }

                if(label) {
                    // console.log(name, value);
                    if(value instanceof File) {

                        if(value.name) {
                            $modalBody.append(`<tr><td>${label.querySelector('.title-text').innerHTML}</td><td>${value.name}</td></tr>`);
                        } else if(label.querySelector('.file-name') && label.querySelector('.file-name').innerText) {
                            $modalBody.append(`<tr><td>${label.querySelector('.title-text').innerHTML}</td><td>${label.querySelector('.file-name').innerText}</td></tr>`);
                        } else {
                            $modalBody.append(`<tr><td>${label.querySelector('.title-text').innerHTML}</td><td></td></tr>`);
                        }
                    } else {
                        if(window.caConfig[name]) {
                            const val = window.caConfig[name][value] ? window.caConfig[name][value] : value;
                            if(name == 'current_fellow') {
                                $modalBody.append(`<tr><td>3. Currently in fellowship</td><td>${val}</td></tr>`);
                            } else if(val) {
                                $modalBody.append(`<tr><td>${label.querySelector('.title-text').innerHTML}</td><td>${val}</td></tr>`);
                            }
                        } else {
                            if(value) {

                                if(name == 'fellow_training_completed_month') {
                                    $modalBody.append(`<tr><td>3. Fellow Training Completed Month</td><td>${value}</td></tr>`);
                                } else if(name == 'fellow_training_completed_year') {
                                    $modalBody.append(`<tr><td>3. Fellow Training Completed Year</td><td>${value}</td></tr>`);
                                } else if(name == 'specialty_other') {
                                    $modalBody.append(`<tr><td>4. Other Area of Specialty</td><td>${value}</td></tr>`);
                                }
                                else {
                                    $modalBody.append(`<tr><td>${label.querySelector('.title-text').innerHTML}</td><td>${value}</td></tr>`);
                                }
                            }
                        }
                    }
                }

            });

        })
        .on('hide.bs.modal', function () {
            console.log('hide.popup');
        });

    $('#climb-application-form-submit').on('click', e => {
        $('.climb-app-form form').submit();
    });

});
